//REGISTER
export const POST_FAKE_REGISTER = "/post-fake-register"
export const POST_LOGIN_TOKEN = "/login"
export const RESET_PASSW = "/resetPasword"
export const CHANGE_PASSW = "/changePasword"
export const SEND_CONFIRMATION = "/verify"
//LOGIN
//export const POST_FAKE_LOGIN = "/post-fake-login"
//export const POST_FAKE_JWT_LOGIN = "/post-jwt-login"
//export const POST_FAKE_PASSWORD_FORGET = "/fake-forget-pwd"
//export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd"

//PROFILE
//export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile"
//export const POST_EDIT_PROFILE = "/post-fake-profile"
//catalogs
//Users Resource (Store, Update, Show, Index)
export const RESOURCE_USERS = "/users"
export const FILE_PROFILE_USER = "/user/file"
export const GET_PROFILES = "/user/profiles"
export const CHANGE_PASSWORD = "/user/change-password"

//Configuration Resource
export const RESOURCE_CONFIGURATIONS = "/configurations"
export const SELECTS_CONFIGURATIONS= "/configuration/selects"
export const GET_ACTIVE_CONFIGURATION = "/configuration/showActive"

//Company Resource
export const RESOURCE_COMPANIES = "/companies"

// Reseller Resource
export const RESOURCE_RESELLER = "/resellers"

//PROFILES -PERMISSIONS
export const RESOURCE_PROFILES = "/profiles"
export const RESOURCE_PERMISSIONS = "/permissions"
export const PERMISSIONS_SELECT = "/permission/selects"

//*******CATALOGOS**********//
//TIPOS DE INSTALACION
export const RESOURCE_INSTALLATION_TYPES = "/catalogs/type_installations"
//condiciones
export const RESOURCE_CONDITIONS = "/catalogs/conditions"

//*******Installations**********//
export const RESOURCE_INSTALLATIONS = "/installations/resource"
export const INSTALLATION_CONDITIONS = "/installations/conditions"
export const RESOURCE_INSTALLATIONS_FILES = "/installations/files"
export const INSTALLATION_TESTS = "/installations/tests"
export const SELECTS_INSTALLATIONS = "/installations/selects"
//*******REPORTS**********//
export const RESOURCE_REPORTS = "/reports"

export const RESOURCE_FILES = "/files"
export const RESOURCE_CATALOGS_V2 = "/catalogs-list"




